import axios from 'axios';

const updateTicketAssigner = params => {
  return axios.put('tickets/ubidesk/settings', params);
};

export { updateTicketAssigner };
